import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, Button } from '@material-ui/core';

export default function UpdateQuesitonDialog({ open, handleClose, action }) {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <DialogContent>
        <DialogContentText id="alert-dialog-description">آیا از ویرایش این سوال اطمینان دارید ؟</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={action} color="primary">
          تایید
        </Button>
        <Button onClick={handleClose} color="secondary" autoFocus>
          انصراف
        </Button>
      </DialogActions>
    </Dialog>
  );
}
